import {
  addApp,
  delApp,
  getClientApps,
  getApps,
  getDataForApp,
  getApp,
  patchApp,
  getAppsParams,
} from "../../helpers/jwt_helper";
import { put, takeEvery, call, select } from "redux-saga/effects";
import {
  setApps,
  showAppLoader,
  hideAppLoader,
  setApp,
  setAppData,
  setClientApps,
} from "./actions";
import {
  GET_CLIENT_APPS,
  GET_APPLICATIONS,
  ADD_APP,
  DELETE_APP,
  GET_APP_DATA,
  GET_APP,
  PATCH_APPLICATION,
  PATCH_APPLICATION_STATUS,
} from "./actionType";
import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetApps({ payload: data }) {
  try {
    data = data || (yield select(state => state.Apps.data));
    yield put(showAppLoader());
    let response = yield call(getAppsParams, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      client: data.client,
      search: data.search,
      is_active: data.is_active,
      is_rent: false,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        created_at: new Date(i.created_at).toDateString(),
      })),
    };
    yield put(setApps(response));
    yield put(hideAppLoader());
  } catch (error) {
    yield put(hideAppLoader());
  }
}

function* onGetClientApps({ payload: { id, params } }) {
  try {
    let response = yield call(getClientApps, id, params);

    if (response.results) {
      response = {
        ...params,
        ...response,
        results: response.results.map(i => ({
          ...i,
          description: i.description === "string" ? "" : i.description,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setClientApps(response));
    yield put(hideAppLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchApp({ payload: { client, id, data } }) {
  try {
    yield call(patchApp, id, data);
    let res = yield call(getClientApps, client);
    yield put(setClientApps(res));
    showSuccessMessage(`Update app ${data.name} has been successfully`);
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchAppStatus({ payload: { id, client_id, data } }) {
  try {
    let response = yield call(patchApp, id, data);
    yield put(setApp(response));
    showSuccessMessage(
      `Application settings has been changed success`
    );
    yield call(onGetClientApps, {
      payload: client_id,
    });
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetApp({ payload: { id } }) {
  try {
    let response = yield call(getApp, id);
    yield put(setApp(response));
    yield put(hideAppLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddApp({ payload: { id, data } }) {
  try {
    yield call(addApp, data);
    let res = yield call(getClientApps, id);
    yield put(setClientApps(res));
    if (data.type == 1) {
      showSuccessMessage(`Added app ${data.name} has been successfully`);
    } else {
      showSuccessMessage(`Added site ${data.name} has been successfully`);
    }
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteApp({ payload: { id, client_id } }) {
  try {
    yield call(delApp, id);
    let res = yield call(getClientApps, client_id);
    yield put(setClientApps(res));
    showSuccessMessage(`Delete app has been successfully`);
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAppData({ payload: { link } }) {
  try {
    yield put(showAppLoader());
    let response = yield call(getDataForApp, link);
    yield put(setAppData(response));
    yield put(hideAppLoader());
  } catch (error) {
    yield put(hideAppLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* appSaga() {
  yield takeEvery(GET_APP, onGetApp);
  yield takeEvery(GET_APPLICATIONS, onGetApps);
  yield takeEvery(GET_CLIENT_APPS, onGetClientApps);
  yield takeEvery(ADD_APP, onAddApp);
  yield takeEvery(DELETE_APP, onDeleteApp);
  yield takeEvery(GET_APP_DATA, onGetAppData);
  yield takeEvery(PATCH_APPLICATION, onPatchApp);
  yield takeEvery(PATCH_APPLICATION_STATUS, onPatchAppStatus);
}

export default appSaga;
